import React, { useRef, useState, useEffect } from 'react';
import styles from '../riquinhocabeleireiro_/riquinhocabeleireiro_.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado9 from '../../components/LinkPersonalizado9/linkPersonalizado9.tsx';

const Riquinhocabeleireiro_: React.FC = () => {


    return (
        <div className={styles.riquinhocabeleireiro_}>
            <div className={styles["body-thunder"]} >
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div>
                        <img width={300} src={Perfil} />
                    </div>
                    <h1 className="mt-4 mb-0">Riquinho</h1>
                    <p className="mb-3">CABELEIREIRO</p>
                    <div className={styles.links}>
                        <LinkPersonalizado9
                            // 98839-5198
                            href="https://wa.me/5517988395198?text=Olá, gostaria de agendar um horário..."
                            title="Whatsapp"
                            colorText="#000000"
                        />
                        <LinkPersonalizado9
                            href="https://maps.app.goo.gl/qB9nmZFRCsog6sqs7"
                            title="Localização"
                            colorText="#000000"
                        />
                        <LinkPersonalizado9
                            href="https://www.instagram.com/riquinhocabeleireiro_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            colorText="#000000"
                        />
                        <LinkPersonalizado9
                            href="https://www.tiktok.com/@riquinhocabeleire?_t=ZM-8vXNgtD1tUl&_r=1"
                            title="Tiktok"
                            colorText="#000000"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Riquinhocabeleireiro_;
